import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../config/firebase";
import { UserAuth } from "../context/AuthContext";

/**
 * Suscribe al entitlement de IA del usuario actual (entitlements/{uid}).
 * Las reglas RTDB permiten que cada usuario lea solo el suyo.
 * Devuelve { ai, expiresAt, loading }.
 */
export function useEntitlement() {
  const { user } = UserAuth();
  const [state, setState] = useState({ ai: false, expiresAt: null, provider: null, loading: true });

  useEffect(() => {
    if (!user || !user.uid) {
      // Espera a que AuthContext resuelva el usuario.
      if (user === null) setState({ ai: false, expiresAt: null, provider: null, loading: false });
      return;
    }
    const r = ref(database, `entitlements/${user.uid}`);
    const unsub = onValue(
      r,
      (snap) => {
        const v = snap.val();
        setState({ ai: v?.ai === true, expiresAt: v?.expiresAt || null, provider: v?.provider || null, loading: false });
      },
      () => setState({ ai: false, expiresAt: null, provider: null, loading: false })
    );
    return () => unsub();
  }, [user]);

  return state;
}
